module.exports = __webpack_public_path__ + "img/4.52237dea.jpg";